<template>
  <div class="flex h-full flex-col">
    <label class="tb-label layer-name mb-3 block">Shoppable Product</label>

    <div
      class="affiliate-controls h-full"
    >
      <div
        v-if="Object.keys(selectedProduct).length"
        class="mt-4"
      >
        <div class="flex gap-4">
          <img
            class="affiliate-image h-20 w-20 flex-none rounded-md object-cover"
            :src="selectedProduct.image"
            alt="Product image"
            data-test="graphics-editor-shoppable-productImage"
          >
          <div class="overflow-hidden">
            <p
              class="cursor-default"
              :data-balloon="selectedProduct.name"
              data-balloon-pos="down"
              data-balloon-length="large"
            >
              <span class="tb-label block">Name</span>
              <span class="ellipsis--two-lines block" data-test="graphics-editor-shoppable-name">{{ selectedProduct.name }}</span>
            </p>
            <p>
              <span class="tb-label">Price</span>
              <span class="ellipsis block" data-test="graphics-editor-shoppable-price">{{ selectedProduct.currentPrice }}</span>
            </p>
          </div>
        </div>

        <p>
          <span class="tb-label">Currency</span>
          <span class="ellipsis block" data-test="graphics-editor-shoppable-currency">{{ selectedProduct.currency }}</span>
        </p>
        <div v-if="shortenerEnabled" class="mt-4">
          <!-- TODO: Finalize copy for tooltip -->
          <p
            title="URL used by the QR Code to enable tracking of scans and more analytics."
            class="tb-label mb-0"
          >
            Short URL
  
            <copy-clipboard
              class="tb-btn tb-btn-text sm small-em"
              data-entity="producer-shoppableSettings-copyShortUrl"
              data-test="graphics-editor-shoppable-copyShortUrl"
              :data-clipboard-text="selectedProduct.shortUrl"
            >
              <span class="fas fa-link"></span>
            </copy-clipboard>
          </p>
  
          <span class="ellipsis" data-test="graphics-editor-shoppable-shortUrl">
            {{ selectedProduct.shortUrl }}
          </span>
        </div>
        <p
          class="mb-0 cursor-default"
        >
          <span class="tb-label">
            Full Product URL
            <a
              :href="selectedProduct.url"
              target="_blank"
              rel="noopener noreferrer"
              class="ml-1 high-em"
              data-test="graphics-editor-shoppable-copyFullUrl"
            ><span class="fas fa-external-link"></span></a>
          </span>
        </p>
        <p class="ellipsis" data-test="graphics-editor-shoppable-fullUrl">{{ selectedProduct.url }}</p>

        <button
          class="tb-btn tb-btn-contained medium-em"
          data-entity="producer-shoppableSettings-removeProduct"
          data-test="graphics-editor-shoppable-removeProduct"
          @click="removeProduct"
        >
          Remove
        </button>
      </div>

      <div
        v-else
          class="flex h-full w-full flex-col items-center justify-center text-center"
        >
          <div>
            <p>Browse the catalog to find items.</p>
            <p>Save them to your collection, then switch to the Shoppable Tab to drag and drop items into the drop zone on your timeline.</p>
            <button
            class="tb-btn tb-btn-contained medium-em"
            data-entity="producer-shoppableSettings-browseCatalog"
            data-test="graphics-editor-shoppable-browseCatalog"
            @click="openCatalogModal"
          >
            <span class="far fa-cart-plus"></span>
            Browse Catalog
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import CopyClipboard from '@/js/shared/copy-clipboard/CopyClipboard.vue';

export default {
  props: ['graphic', 'element', 'graphic_fields'],
  components: {
    CopyClipboard,
  },

  data() {
    return {
      shortenerEnabled: process.env.QR_CODE_SWITCH === 'ON',
    };
  },

  computed: {
    ...mapState({
      production(state) {
        return state.production.production;
      },
    }),
    computedFields() {
      return (
        this.graphic.fields?.[this.element.id]
        || this.graphic_fields?.[this.element.id]
      ) ?? {};
    },

    data: {
      get() {
        return this.computedFields.data ?? this.element.data;
      },

      set(value) {
        this.$emit('value', { value, field: 'data' });
      },
    },

    selectedProduct() {
      return this.data?.selectedProduct ?? {};
    },
  },
  methods: {
    ...mapActions('shoppable', ['openCatalogModal']),
    removeProduct() {
      this.data = {
        type: null,
        selectedProduct: {},
      };
    },
  },
};
</script>
